interface CountryTabsProps {
  selectedCountry: string;
  onSelectCountry: (country: string) => void;
}

const countries = [
  { id: 'saudi-arabia', name: 'Saudi Arabia', icon: 'ri-building-line' },
  { id: 'turkey', name: 'Turkey', icon: 'ri-landscape-line' },
  { id: 'uae', name: 'UAE', icon: 'ri-skyscraper-line' },
  { id: 'morocco', name: 'Morocco', icon: 'ri-ancient-gate-line' },
  { id: 'egypt', name: 'Egypt', icon: 'ri-sun-line' },
  { id: 'jordan', name: 'Jordan', icon: 'ri-map-pin-2-line' },
  { id: 'malaysia', name: 'Malaysia', icon: 'ri-building-2-line' },
  { id: 'indonesia', name: 'Indonesia', icon: 'ri-palm-tree-line' },
  { id: 'maldives', name: 'Maldives', icon: 'ri-ship-line' },
  { id: 'bosnia', name: 'Bosnia', icon: 'ri-castle-line' }
];

export default function CountryTabs({ selectedCountry, onSelectCountry }: CountryTabsProps) {
  return (
    <div className="bg-white sticky top-[72px] z-40 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-6">
        <div className="flex items-center justify-center gap-4 flex-wrap">
          {countries.map((country) => (
            <button
              key={country.id}
              onClick={() => onSelectCountry(country.id)}
              className={`px-8 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
                selectedCountry === country.id
                  ? 'bg-[#C9A961] text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <i className={`${country.icon} text-lg`}></i>
              {country.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}